export default __webpack_public_path__ + "static/media/dropdown.fdf30fcf.svg";